import { createFormContext } from '@mantine/form';

interface FormValues {
    firstname: string;
    lastname: string;
    middlename: string;
    company: string;
    unit: string;
    position: string;
    phone: string;
    email: string;
    title: string;
    flag: boolean;
    check: boolean;
    event: string;
}

export const [FormProvider, useFormContext, useForm] = createFormContext<FormValues>();